import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { AuthProvider }
from '../../components/AuthProvider';
import LookbookGallery from '../../components/Lookbook/Gallery';
import Head from '../../components/Head';
import withApollo from '../../lib/apollo';
import withQuery from '../../lib/withQuery';
import throw404 from '../../lib/throw404';
import imageCategoryQuery
from '../../lib/queries/lookbook/imageCategory.graphql';
import redirectRouteToDomain from '../../lib/redirectRouteToDomain';

const Category = (properties) => {
  const {
    data: { imageCategory },
  } = properties;

  if (!imageCategory) {
    return throw404();
  }

  const { id, title, slug } = imageCategory;

  return (
    <AuthProvider>
      <Head
        title={`${title} - Worldwide Fashion Design Lookbook`}
          // eslint-disable-next-line max-len
        description="Share, Create, Inspire and Showcase design on the international network for fashion professionals. Upload your design here."
        subjectType="ImageCategory"
        subjectId={id}
      />
      <LookbookGallery
        searchLabel={title}
        categorySlug={slug}
        route="lookbookCategory"
        withUploader
      />
    </AuthProvider>
  );
};

Category.propTypes = {
  data: PropTypes.shape({
    imageCategory: PropTypes.shape({
      title: PropTypes.string,
      slug: PropTypes.string,
    }),
  }),
};

Category.defaultProps = {
  data: {},
};

const CategoryWithQuery = withQuery(Category);

const CategoryPage = () => {
  const { query: { categoryId } } = useRouter();

  return (
    <CategoryWithQuery
      query={imageCategoryQuery}
      variables={{ id: Number(categoryId) }}
      errorMessage="Error loading images for this category"
    />
  );
};

CategoryPage.getInitialProps = redirectRouteToDomain('lookbookCategory');

export default withApollo(CategoryPage);
